import axios, {
  type AxiosError,
  type AxiosInstance,
  type InternalAxiosRequestConfig,
} from "axios";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

import { config } from "../config";

export const apiClient: AxiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use(
  async (req: InternalAxiosRequestConfig) => {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
    if (accessToken) {
      req.headers.set("Authorization", `Bearer ${accessToken}`);
    }
    return req;
  },
);

apiClient.interceptors.response.use(
  (resp) => resp,
  async (error: AxiosError) => {
    // 401 means the access token isn't valid — clear Amplify's session so
    // the splash treats the user as signed out cleanly. 503 from
    // /api/auth/me is the post-confirmation-Lambda race; AuthProvider
    // handles that as a soft "provisioning" state — DO NOT sign out for it.
    if (error.response?.status === 401) {
      try {
        await signOut();
      } catch {
        // signOut may itself fail if there's no session — swallow.
      }
    }
    return Promise.reject(error);
  },
);
